import loadConfig from '../loadConfig.js';

const getSquareConfig = async () => {
  const { square: { appId, locationId, isProduction } } = await loadConfig();

  return { appId, locationId, isProduction };
};

export default getSquareConfig;